<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="main_wrap" id="main_wrap" v-if="shown.mainshow"
        v-loading.fullscreen.lock="pageData.productFullscreenLoading" :element-loading-text="$t('App.text.load_info')">
        <div class="commonhead"></div>
        <div class="head_wrap">
          <com-head></com-head>
          <div class="nav_bar">
            <el-menu :default-active="pageData.headMenu.activeIndex" background-color="#323233" class="menu_items"
              text-color="#ffffff" active-text-color="#f96508" mode="vertical" @select="menuSelected">
              <el-menu-item :index="index + ''" :key="item + index"
                v-for="(item, index) in pageData.headMenu.itemInList" @click="scrollTo(item.name)"
                v-show="item.items.length != 0" class="menuitem_items">{{ item.name_bak }}</el-menu-item>
            </el-menu>
          </div>

          <div class="cart_pop">
            <span class="el-icon-shopping-cart-1" @click="routerToCart"></span>
          </div>
          <div class="search_pop">
            <div>
              <el-input :placeholder="$t('App.text.placeholder_search')" v-model="pageData.gloablSearch" clearable
                show-word-limit maxlength="50" autocomplete="on" @change="searchProducts(pageData.gloablSearch)"
                size="mini">
              </el-input>
            </div>
            <div>
              <el-button type="primary" size="mini">{{
                $t('App.text.search')
              }}</el-button>
            </div>
          </div>
        </div>
        <div class="body_wrap">
          <div v-infinite-scroll="loadProducts" style="overflow: auto; margin-top: 12rem">
            <div class="items_wrap" :id="'items_wrap' + index" v-for="(items, index) in pageData.headMenu.itemInList"
              :key="items + index" :index="index + ''">
              <div :id="'title_class' + index" style="padding-bottom: 3rem">
                <div :id="items.name" v-if="items.items.length != 0">
                  <el-row>{{ items.name_bak }}&nbsp; </el-row>
                </div>
              </div>
              <el-row class="card_row">
                <el-col :span="6" v-for="(item, itemIndex) in items.items" :key="itemIndex" v-show="item.searchFlag"
                  class="card_col">
                  <el-tooltip effect="dark" placement="top" :enterable="false" :open-delay="1000">
                    <div slot="content" style="line-height: 200%; width: 20rem">
                      <div>
                        {{ $t('App.page.details.label_sku') }}{{ item.sku }}
                      </div>
                      <div>
                        {{ $t('App.page.details.label_ean') }}{{ item.ean }}
                      </div>
                      <div>
                        {{ $t('App.page.details.label_weight')
                        }}{{ item.weight }}
                      </div>
                      <div>
                        {{ $t('App.page.details.label_rweight')
                        }}{{ item.rweight }}
                      </div>
                      <div>
                        {{ $t('App.page.details.label_boxpcs')
                        }}{{ item.boxpcs }}
                      </div>
                      <div>
                        {{ $t('App.page.details.label_feature')
                        }}{{ item.feature }}
                      </div>
                      <div>
                        {{ $t('App.page.details.label_description')
                        }}{{ item.description }}
                      </div>
                    </div>
                    <el-badge type="primary" v-if="Number(item.brand || 0) % 2 == 0" :value="item.brandName || ''"
                      class="item">
                      <el-card :body-style="{ padding: '0px' }" shadow="hover" class="card_items">
                        <div v-if="item.fid == '03-08-001-0012-00'" style="
                            position: absolute;
                            width: 12.5vw;
                            height: 2rem;
                            float: left;
                            overflow: hidden;
                          ">
                          <el-alert :title="$t('App.page.home.notice_demoprice_dealer')" type="error" :closable="false"
                            effect="dark">
                          </el-alert>
                        </div>
                        <div v-else-if="item.fid == '03-12-007-0001-00'" style="
                            position: absolute;
                            width: 12.5vw;
                            height: 2rem;
                            float: left;
                            overflow: hidden;
                          ">
                          <el-alert :title="$t('App.page.home.notice_goldbar')" type="error" :closable="false"
                            effect="dark">
                          </el-alert>
                        </div>

                        <div class="card_img_wrap">
                          <!-- <el-image
                            @click="toDetails(item)"
                            class="img_items"
                            :src="'data:image/jpg;base64,' + item.img"
                            lazy
                          > -->
                          <el-image v-if="item && item.img && item.img.length > 0" :src="formatProductImage(item.img)"
                            @click="toDetails(item)">
                            <div slot="placeholder" class="image-slot">
                              {{ $t('App.text.loading') }}
                            </div>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline" style="font-size: 3rem; margin-top: 5rem"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="card_main">
                          <div class="prod_name_content">
                            <span><i style="
                                  font-style: normal;
                                  color: #606266;
                                  font-size: 0.7rem;
                                ">{{ item.name }}</i></span>
                            <i v-show="false">{{ item.name_bak }}</i>
                          </div>
                          <div class="card_footer">
                            <!-- TODO:价格显示 -->
                            <div style="margin-top: 2rem; margin-bottom: 2rem">
                              <span style="vertical-align: middle"><span style="font-size: 0.8rem; color: #f13a3a">
                                  {{ item.sign }}</span><span style="font-size: 1.1rem; color: #f13a3a">{{
                                    item.saleprice }}</span></span>
                              <el-input-number controls-position="right" :min="1" :max="9999" size="mini"
                                v-model="item.quantity" v-if="
                                  item.id == 'PD830215946' ||
                                  item.id == 'PD8302305836' ||
                                  item.id == 'PD3486991625' ||
                                  item.id == 'PD3486995656'
                                " :step="30" step-strictly></el-input-number>
                              <el-input-number :min="1" :max="9999" size="mini" v-model="item.quantity"
                                v-else></el-input-number>
                              <el-tooltip effect="dark" :content="$t('App.page.home.cart')" placement="right">
                                <el-button circle type="success" class="el-icon-shopping-bag-2" size="mini"
                                  style="font-size: 0.8rem" @click="toCart(item)"></el-button>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </el-card>
                    </el-badge>

                    <el-badge v-if="Number(item.brand || 0) % 2 !== 0" :value="item.brandName || ''" class="item">
                      <el-card :body-style="{ padding: '0px' }" shadow="hover" class="card_items">
                        <div v-if="item.fid == '03-08-001-0012-00'" style="
                            position: absolute;
                            width: 12.5vw;
                            height: 2rem;
                            float: left;
                            overflow: hidden;
                          ">
                          <el-alert :title="$t('App.page.home.notice_demoprice_dealer')" type="error" :closable="false"
                            effect="dark">
                          </el-alert>
                        </div>
                        <div v-else-if="item.fid == '03-12-007-0001-00'" style="
                            position: absolute;
                            width: 12.5vw;
                            height: 2rem;
                            float: left;
                            overflow: hidden;
                          ">
                          <el-alert :title="$t('App.page.home.notice_goldbar')" type="error" :closable="false"
                            effect="dark">
                          </el-alert>
                        </div>

                        <div class="card_img_wrap">
                          <!-- <el-image
                            @click="toDetails(item)"
                            class="img_items"
                            :src="'data:image/jpg;base64,' + item.img"
                            lazy
                          > -->
                          <el-image v-if="item && item.img && item.img.length > 0" :src="formatProductImage(item.img)"
                            @click="toDetails(item)">
                            <div slot="placeholder" class="image-slot">
                              {{ $t('App.text.loading') }}
                            </div>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline" style="font-size: 3rem; margin-top: 5rem"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="card_main">
                          <div class="prod_name_content">
                            <span><i style="
                                  font-style: normal;
                                  color: #606266;
                                  font-size: 0.7rem;
                                ">{{ item.name }}</i></span>
                            <i v-show="false">{{ item.name_bak }}</i>
                          </div>
                          <div class="card_footer">
                            <div style="margin-top: 2rem; margin-bottom: 2rem">
                              <span style="vertical-align: middle"><span style="font-size: 0.8rem; color: #f13a3a">
                                  {{ item.sign }}</span><span style="font-size: 1.1rem; color: #f13a3a">{{
                                    item.saleprice }}</span></span>
                              <el-input-number controls-position="right" :min="1" :max="9999" size="mini"
                                v-model="item.quantity" v-if="
                                  item.id == 'PD830215946' ||
                                  item.id == 'PD8302305836' ||
                                  item.id == 'PD3486991625' ||
                                  item.id == 'PD3486995656'
                                " :step="30" step-strictly></el-input-number>
                              <el-input-number :min="1" :max="9999" size="mini" v-model="item.quantity"
                                v-else></el-input-number>
                              <el-tooltip effect="dark" :content="$t('App.page.home.cart')" placement="right">
                                <el-button circle type="success" class="el-icon-shopping-bag-2" size="mini"
                                  style="font-size: 0.8rem" @click="toCart(item)"></el-button>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </el-card>
                    </el-badge>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <el-empty v-if="pageData.headMenu.itemInList.length === 0"></el-empty>
          </div>
        </div>
        <div class="foot_wrap"><com-foot></com-foot></div>
        <div class="trans_cart">
          <transition name="transcart">
            <div class="animat_cartitem" v-if="shown.cartItemShow"></div>
          </transition>
        </div>
      </div>
    </transition>
    <el-backtop style="right: 3%"> </el-backtop>
  </div>
</template>

<script>
import Vue from 'vue'
import Head from '@/components/customer/customerCommonHeader'
import Foot from '@/components/customer/customerCommonFooter'
import * as commonjs from '@/assets/js/common'
import * as cartjs from '@/assets/js/cart'
import * as verifyjs from '@/assets/js/verify'
export default {
  data() {
    return {
      api: '',
      shown: {
        mainshow: false,
        cartItemShow: false,
      },
      pageData: {
        productFullscreenLoading: true,

        username: '',
        newCartItem: {},
        user: {},
        custUserinfo: {},
        loadProductsCount: 0,
        headMenu: {
          activeIndex: '',
          itemInList: [],
        },
        currency_r: {},
        prices_in_currency: [],
        discountRules: [],
        gloablSearch: '',
        recommendList: [
          { url: require('@/assets/images/test.jpg') },
          { url: require('@/assets/images/test1.jpg') },
          { url: require('@/assets/images/test2.jpg') },
          { url: require('@/assets/images/test3.jpg') },
          { url: require('@/assets/images/test4.jpg') },
        ],
        current_brand: 0,
      },
      formData: {},
    }
  },
  mounted() {
    this.prepareForMounted()
  },
  methods: {
    prepareForMounted() {
      this.pageData.username = sessionStorage.getItem('username')
      this.pageData.custUserinfo = JSON.parse(
        sessionStorage.getItem(this.pageData.username),
      )
      // Set api prefix for image URL construction
      this.api =
        (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.API_PREFIX) ||
        process.env.API_PREFIX ||
        ''
      if (this.pageData.custUserinfo.brand_list === 1) {
        this.pageData.current_brand = 1
      } else {
        this.pageData.current_brand = 0
      }
      if (verifyjs.isMounted(this)) {
        document.title = this.$t('App.title.home')
        this.getAllProducts()
        commonjs.getCountry(this)
        setTimeout(() => {
          this.shown.mainshow = true
        }, 1)
      } else {
        console.log('首页返回登录页', this)

        this.$router.push({ name: 'Login' })
      }
    },
    loadProducts() {
      this.pageData.loadProductsCount += 1
    },
    formatProductImage(img) {
      if (!img || img.length === 0) return ''
      // If already base64 or full URL, return as is
      if (img.indexOf('data:image') === 0 || img.indexOf('http') === 0) {
        return img
      }
      // If starts with images/ or /images/, prepend the product image server URL
      if (img.indexOf('images/') === 0 || img.indexOf('/images/') === 0) {
        // Convert 'images/xxx.jpg' or '/images/xxx.jpg' to '/images/xxx.jpg'
        const cleanImg = img.replace(/^images\//, '/images/')
        return cleanImg
      }
      // Otherwise, prepend API prefix
      return (this.api || '') + img
    },
    menuSelected(key, keyPath) { },
    scrollTo(domid) {
      document
        .getElementById(domid)
        .scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    swithBrand() {
      if (this.pageData.current_brand === 1) {
        this.pageData.current_brand === 0
      } else {
        this.pageData.current_brand === 1
      }
    },
    getAllProducts() {
      this.$axios({
        method: 'post',
        // url: Vue.prototype.api + '6002/api/local/selectProducts',
        url: Vue.prototype.api + 'api/local/selectProducts',
        data: this.pageData.custUserinfo,
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.code == '200') {
              let list = []
              this.pageData.headMenu.itemInList = []
              list = response.data.data
              this.pageData.discountRules = response.data.k3err
              if (
                JSON.parse(sessionStorage.getItem('disocunt_rules')) == null
              ) {
                sessionStorage.setItem(
                  'disocunt_rules',
                  JSON.stringify(this.pageData.discountRules),
                )
              }

              for (let index in list) {
                if (list[index].items.length != 0) {
                  this.pageData.headMenu.itemInList.push(list[index])
                }
              }

              for (let classer of this.pageData.headMenu.itemInList) {
                for (let product of classer.items) {
                  product.searchFlag = true
                }
              }

              this.pageData.productFullscreenLoading = false

              this.loadProductsImages()
              let currency = {}
              currency.id = this.pageData.custUserinfo.currency
              this.getPrdls(currency)
            } else if (response.data.code == '210') {
              this.$notify.warning({
                title: this.$t('App.notify.title_nofity'),
                message: this.$t('App.notify.content_noresult'),
              })

              this.pageData.productFullscreenLoading = false
              return
            } else {
              console.log(1)

              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_servererr'),
              })

              this.pageData.productFullscreenLoading = false
              return
            }
          } else {
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_server') + response.status,
            })

            this.pageData.productFullscreenLoading = false
            return
          }
        })
        .catch((error) => {
          console.log(error, 2)

          this.$notify.error({
            title: this.$t('App.notify.title_server'),
            message: this.$t('App.notify.content_servererr'),
          })

          this.pageData.productFullscreenLoading = false
          return
        })
    },
    getPrdls(currency) {
      this.$axios({
        method: 'post',
        // url: Vue.prototype.api + '6002/api/local/product/details/required/get',
        url: Vue.prototype.api + 'api/local/product/details/required/get',
        data: { id: currency.id, userName: this.pageData.username },
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.code == '200') {
              this.pageData.prices_in_currency = response.data.data.prices
              this.pageData.currency_r = response.data.data.currency

              if (JSON.stringify(this.pageData.currency_r.sign) === 'null') {
                this.pageData.currency_r.sign = '$'
              }

              sessionStorage.setItem('cust_sign', this.pageData.currency_r.sign)
              sessionStorage.setItem('cust_abbr', this.pageData.currency_r.abbr)
              if (this.pageData.prices_in_currency.length > 0) {
                for (let price of this.pageData.prices_in_currency) {
                  price.sign = this.pageData.currency_r.sign
                  price.abbr = this.pageData.currency_r.abbr
                  price.c_id = this.pageData.currency_r.id
                  price.name = this.pageData.currency_r.name
                  price.name_en = this.pageData.currency_r.name_en
                }

                this.pageData.headMenu.itemInList =
                  this.pageData.headMenu.itemInList.filter((items) => {
                    items.items = items.items.filter((item) => {
                      const pc = this.pageData.prices_in_currency.find(
                        (price) => price.product_id == item.id,
                      )

                      if (!pc || Number(pc.price) <= 0) {
                        return false
                      }

                      item.sign = pc.sign
                      item.abbr = pc.abbr
                      item.currency_name = pc.name
                      item.currency_name_en = pc.name_en
                      item.saleprice = pc.price
                      return true
                    })

                    return items.items.length > 0
                  })
                  console.log(this.pageData.headMenu.itemInList, "所有产品数据")
              }
            } else {
              console.log(3)
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_servererr'),
              })

              return
            }
          } else {
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_server') + response.status,
            })

            return
          }
        })
        .catch((error) => {
          console.log(error, 4)

          this.$notify.error({
            title: this.$t('App.notify.title_server'),
            message: this.$t('App.notify.content_servererr'),
          })

          return
        })
    },
    loadProductsImages() {
      this.$axios({
        method: 'post',
        // url: Vue.prototype.api + '6002/api/local/loadImagesByProductId',
        url: Vue.prototype.api + 'api/local/loadImagesByProductId',
        data: this.pageData.custUserinfo,
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.code == '200') {
              for (let classer of this.pageData.headMenu.itemInList) {
                for (let product of classer.items) {
                  for (let productImgs of response.data.data) {
                    if (productImgs.id == product.id) {
                      product.img = productImgs.img
                    }
                  }
                }
              }
            } else {
              console.log(5)

              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_servererr'),
              })

              return
            }
          } else {
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_server') + response.status,
            })

            return
          }
        })
        .catch((error) => {
          console.log(error, 6)

          this.$notify.error({
            title: this.$t('App.notify.title_server'),
            message: this.$t('App.notify.content_servererr'),
          })

          this.pageData.productFullscreenLoading = false
          return
        })
    },
    toDetails(item) {
      let router = this.$router.resolve({ name: 'Details', query: item })
      setTimeout(() => {
        window.open(router.href, '_blank')
      }, 100)
    },
    allClassToCart(index) {
      if (this.pageData.headMenu.itemInList[index].items.length > 8) {
        this.$notify.warning({
          title: this.$t('App.notify.title_nofity'),
          message: this.$t('App.page.home.notify_series_outofsize'),
        })
        return
      }
      for (let item of this.pageData.headMenu.itemInList[index].items) {
        item.quantity = 1
        setTimeout(() => {
          this.toCart(item)
        }, 200)
      }
    },
    toCart(item) {
      if (
        item.id == 'PD830215946' ||
        item.id == 'PD8302305836' ||
        item.id == 'PD3486991625' ||
        item.id == 'PD3486995656'
      ) {
        if (item.quantity % 30 != 0) {
          return
        }
      }

      if (
        item.quantity === null ||
        item.quantity === 0 ||
        item.quantity === '' ||
        item.quantity === undefined
      ) {
        return
      } else {
        this.pageData.newCartItem.productid = item.id
        this.pageData.newCartItem.productname = item.name
        this.pageData.newCartItem.quantity = item.quantity
        this.pageData.newCartItem.uniprice = item.saleprice
        this.pageData.newCartItem.scount = this.pageData.custUserinfo.discount
        this.pageData.newCartItem.disprice =
          this.pageData.newCartItem.uniprice *
          (1 - this.pageData.newCartItem.scount)
        this.pageData.newCartItem.subprice = 0.0
        this.pageData.newCartItem.weight = item.weight
        this.pageData.newCartItem.rweight = item.rweight
        this.pageData.newCartItem.sign = item.sign
        this.pageData.newCartItem.img = item.img

        this.pageData.user.username = this.pageData.username

        cartjs.addToCart(this, this.pageData.user, this.pageData.newCartItem)

        this.cartAnimat()

        item.quantity = undefined
      }
    },
    routerToCart() {
      // let targetCart = this.$router.resolve({ name: 'Cart' })
      // window.open(targetCart.href, '_blank')
      const { href } = this.$router.resolve({ name: 'Cart' })
      const winName = `cart_${Date.now()}` // 永远不一样
      window.open(`${href}?t=${Date.now()}`, winName)
    },
    cartAnimat() {
      this.shown.cartItemShow = true
      setTimeout(() => {
        this.shown.cartItemShow = false
      }, 500)
    },
    //去空格方法
    trimAll(str) {
      if (!str) return ''
      // \s 匹配：半角空格、全角空格、\t\r\n各种空白
      return String(str).replace(/\s+/g, '')
    },
    searchProducts(val) {
      if (verifyjs.strIsEmpty(val)) {
        for (let q = 0; q < this.pageData.headMenu.itemInList.length; q++) {
          let s = document.getElementById('items_wrap' + q)
          s.style.margin = '0 auto 15rem'
          let y = document.getElementById('title_class' + q)
          y.style.display = 'block'
          y.style.paddingBottom = '3rem'
        }
        for (let classer of this.pageData.headMenu.itemInList) {
          for (let product of classer.items) {
            this.$nextTick(() => {
              product.searchFlag = true
              product.name_bak = new Date().getTime()
            })
          }
        }
      } else {
        const key = this.trimAll(val).toLowerCase()
        for (let q = 0; q < this.pageData.headMenu.itemInList.length; q++) {
          let s = document.getElementById('items_wrap' + q)
          s.style.margin = '0 auto 0'
          let y = document.getElementById('title_class' + q)
          y.style.display = 'none'
        }
        for (let classer of this.pageData.headMenu.itemInList) {
          for (let product of classer.items) {
            if (this.trimAll(product.name).toLowerCase().includes(key)) {
              this.$nextTick(() => {
                product.searchFlag = true
                product.name_bak = new Date().getTime()
              })
            } else {
              this.$nextTick(() => {
                product.searchFlag = false
                product.name_bak = new Date().getTime()
              })
            }
          }
        }
      }
    },
  },
  components: {
    'com-head': Head,
    'com-foot': Foot,
  },
}
</script>

<style scoped>
.main_wrap {
  background-color: #ffffff;
  width: 120rem;
  height: 100%;
}

.head_wrap {
  width: 100%;
  /* height: 100%; */
  position: fixed;
  z-index: 999;
  /* margin-top: -3rem; */
  /* margin: 0 auto; */
}

.pan_recommend {
  width: 80%;
  margin: 0 auto;
  margin-top: 7rem;
}

.cart_pop {
  position: fixed;
  display: table;
  z-index: 999;
  border-radius: 50%;
  background-color: #ffffff;
  width: 2.6rem;
  height: 2.6rem;
  box-shadow: 0px 0px 0.2rem #909399;
  right: 3%;
  bottom: 11%;
}

.cart_pop span {
  font-size: 1.5rem;
  color: #409eff;
  display: table-cell;
  vertical-align: middle;
}

.cart_pop:hover {
  background-color: #ffffff;
}

.search_pop {
  border-radius: 0.2rem;
  display: flex;
  position: fixed;
  z-index: 999;
  width: 20rem;
  top: 5rem;
  right: -1rem;
  /* top: 0.5rem; */
  /* right: 6%; */
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.nav_bar {
  width: 10rem;
  /* margin: auto; */
  /* margin-top: -2.5rem; */
  margin-left: 2rem;
  position: fixed;
  overflow: auto;
  height: 80vh;
}

.nav_bar li {
  font-size: 0.8rem;
}

.menu_items {
  /* display: flex; */
  margin: auto;
  height: 100%;
}

/* .menuitem_items {
  width: 10%;
} */
.body_wrap {
  /* margin-top: 6rem; */
  overflow: auto;
}

.items_wrap {
  margin: 0 auto 15rem;
  width: 70%;
  font-style: normal;
  color: #606266;
  font-size: 1.3rem;
}

.card_col {
  margin-top: 2rem;
}

.card_items {
  height: auto;
  width: 12.5vw;
  margin-left: 2rem;
  /* margin-top: 2rem; */
  margin-bottom: 1rem;
  overflow: auto;
}

.card_main {
  line-height: 1rem;
}

.prod_name_content {
  position: relative;
  width: 90%;
  margin: auto;
  margin-top: 0.7rem;
  height: 1rem;
}

.prod_price_content {
  margin-top: 2.5rem;
  height: 1rem;
}

.bottom {
  margin-top: 0.5rem;
  line-height: 0.5rem;
}

.card_footer {
  /* overflow: auto; */
  overflow: hidden;
  position: relative;
}

.card_img_wrap {
  overflow: hidden;
}

.img_items {
  width: 95%;
  display: block;
  margin: 2rem auto;
  height: 20rem;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.transcart-enter-active {
  transition: all 0.5s ease-out;
}

.transcart-enter {
  opacity: 0;
  transform: scale(0.5);
  transform: translate(-10rem, -5rem);
}

.transcart-leave-active {
  opacity: 0;
}

.trans_cart {
  position: fixed;
  top: 80%;
  left: 93%;
  z-index: 88;
}

.animat_cartitem {
  width: 2rem;
  height: 2rem;
  background-color: #606266;
  box-shadow: 0px 0px 0.2rem #909399;
  position: absolute;
  border-radius: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/customer/Home.vue